export default "__VITE_ASSET__D1w_2eVn__"